export enum KeyCode {
  Enter = 'Enter',
  Space = 'Space',
  Left = 'ArrowLeft',
  Up = 'ArrowUp',
  Right = 'ArrowRight',
  Down = 'ArrowDown',
  Escape = 'Escape',
}
